<template>
  <v-container>
    <v-row text-xs-center wrap>
      <v-col cols="12">
        <v-img :src="require('../assets/logo.png')"
               class="my-3"
               contain
               height="200" />
      </v-col>

      <v-col class="text-center" cols="12">
        <h1 class="display-2 font-weight-bold mb-3">
          HawkSoft
        </h1>
        <p class="subheading font-weight-regular">
          Welcome to HawkSoft Agent Portal
        </p>
      </v-col>

      <v-col class="text-center" cols="12">
        <v-btn class="opportunity" to="/search">Search for a Client</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
</style>

<script>
export default {
  computed: {
    environment () {
      return localStorage.getItem('environment');
    }
  }
};
</script>
